export default function NotFoundPage() {
  return (
    <div className="p-4">
      <h1 className="text-xl text-gray-400">页面不存在 — 返回首页</h1>
      <a
        href="/"
        className="inline-block mt-4 text-blue-500 hover:text-blue-600"
      >
        ← 返回首页
      </a>
    </div>
  );
}
